export default __webpack_public_path__ + "medical_mb2b77f.jpg";